import { motion } from "framer-motion";
import { CreditCard, Unlock, RefreshCw } from "lucide-react";

const steps = [
  {
    icon: CreditCard,
    title: "Quick Secure Payment",
    description: "Subscribers navigate to your link and pay via Razorpay. No sign-up required.",
    color: "text-golden-accent",
  },
  {
    icon: Unlock,
    title: "Instant Channel Access",
    description: "Our automation instantly grants access on Telegram, Discord, and Slack for paid subscribers.",
    color: "text-functional-success",
  },
  {
    icon: RefreshCw,
    title: "Automated Renewals",
    description: "We handle expiry, access revocation, and WhatsApp reminders automatically.",
    color: "text-functional-info",
  },
];

export default function LandingSubscriberExperience() {
  return (
    <section className="relative py-24 bg-dark-primary">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            className="mb-16 md:mb-24"
        >
            <h2 className="text-4xl md:text-6xl font-extrabold font-outfit text-text-primary uppercase tracking-tight">
              Frictionless for <br/>
              <span className="text-golden-accent">Your Audience</span>
            </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12 lg:gap-16">
          {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="group relative text-left"
            >
              <div className="flex items-center gap-4 mb-6">
                 <div className={`p-3 rounded-full bg-dark-secondary/50 border border-dark-border ${step.color}`}>
                    <step.icon size={32} strokeWidth={1.5} />
                 </div>
                 <div className="h-px bg-dark-border flex-1 group-hover:bg-golden-accent/50 transition-colors" />
              </div>
              
              <h3 className="text-2xl font-bold font-outfit text-text-primary mb-3">
                {step.title}
              </h3>
              <p className="text-lg text-text-secondary leading-relaxed font-light">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
